/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/trigger_iam" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsTriggerIam } from "./constants";
import type { AppsAppGroupIdChartsTriggerIamResult } from "./types";

export const getAppsAppGroupIdChartsTriggerIam = reactQueryFetcherAdapter(
  appsAppGroupIdChartsTriggerIam,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsTriggerIamResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/trigger_iam`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal }
    );
  }
);
